export const getSlotStyle = (state, theme) => {
    let backgroundColor = '#666';
    if (typeof state === 'string') {
        if (state === 'Available') backgroundColor = '#16a085';
        if (state === 'Expired') backgroundColor = '#666';
    } else {
        if (state?.JitAuction) backgroundColor = '#297cb3';
        if (state?.AotAuction) backgroundColor = theme.accent;
        if (state?.Reserved) backgroundColor = theme.gold;
        if (state?.Filled) backgroundColor = '#dc2626';
    }
    return { backgroundColor };
};

export const getStateName = (state) => {
    if (typeof state === 'string') return state;
    if (state?.JitAuction) return 'JIT Auction';
    if (state?.AotAuction) return 'AOT Auction';
    if (state?.Reserved) return 'Reserved';
    if (state?.Filled) return 'Filled';
    return 'Unknown';
};

export const getTransactionStatus = (status) => {
    if (typeof status === 'string') return status;
    if (status?.Included) return 'Included';
    if (status?.AuctionWon) return 'Auction Won';
    if (status?.Failed) return 'Failed';
    return 'Pending';
};

export const getTransactionType = (type) => {
    if (typeof type === 'string') return type;
    if (type?.Jit) return 'JIT';
    if (type?.Aot) return `AOT (Slot ${type.Aot.reserved_slot})`;
    return 'Standard';
};

export const getStatusColor = (status) => {
    switch (status) {
        case 'connected':
            return '#16a085'; // Teal Green
        case 'error':
            return '#e74c3c'; // Red
        case 'disconnected':
        default:
            return '#666'; // Gray
    }
};
